/**
 * Sanity check for elements in components
 *
 * Use for runtime check to make sure the content matches the expected schema, and throw
 * instead of failing silently.
 *
 * Note: These must NOT be added to components as that is not supported by
 * nuxt, put them in the component itself (e.g. on the root `div`).
 *  @see https://vuejs.org/guide/reusability/custom-directives.html#usage-on-components
 *
 */

import type { Directive } from 'vue';

// not sure 100% if this is the right way to do it or is needed
declare module 'vue' {
  interface Directives {
    'sc-non-empty-string': Directive;
    'sc-non-empty': Directive;
  }
}

export default defineNuxtPlugin({
  name: 'sanity-check-plugin',
  parallel: true,
  async setup(nuxtApp) {
    nuxtApp.vueApp.directive('sc-non-empty-string', {
      updated(_, binding) {
        scNonEmptyString(binding.value, {
          named: binding.instance?.$options,
          msg: 'v-sc-non-empty-string',
        });
      },
    });

    nuxtApp.vueApp.directive('sc-non-empty', {
      updated(_, binding) {
        scNonEmpty(binding.value, { named: binding.instance?.$options, msg: 'v-sc-non-empty' });
      },
    });
  },
});
